import { render } from "./Back.vue?vue&type=template&id=9c2355b0&scoped=true&ts=true"
import script from "./Back.vue?vue&type=script&lang=ts"
export * from "./Back.vue?vue&type=script&lang=ts"

import "./Back.vue?vue&type=style&index=0&id=9c2355b0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c2355b0"]])

export default __exports__